import { z } from "zod";
import { DTOFigmaNodeRenderIdInput, DTOFigmaNodeRenderInput } from "./figma-node";
import { DTOFigmaNode } from "./figma-node-v1";
import { DTOFigmaNodeV2 } from "./figma-node-v2";

//
// Read
//

/**
 * @deprecated Please use FigmaNodeRenderAsync (DTOFigmaNodeRenderAsyncActionOutput)
 */
export const DTOFigmaNodeRenderActionOutput = z.object({
  type: z.literal("FigmaNodeRender"),
  figmaNodes: z.array(DTOFigmaNode),
});

export const DTOFigmaNodeRenderAsyncActionOutput = z.object({
  type: z.literal("FigmaNodeRenderAsync"),
  figmaNodes: z.array(DTOFigmaNodeV2),
});

export type DTOFigmaNodeRenderActionOutput = z.infer<typeof DTOFigmaNodeRenderActionOutput>;
export type DTOFigmaNodeRenderAsyncActionOutput = z.infer<typeof DTOFigmaNodeRenderAsyncActionOutput>;

//
// Read
//

/**
 * @deprecated Please use FigmaNodeRenderAsync (DTOFigmaNodeRenderAsyncActionInput)
 */
export const DTOFigmaNodeRenderActionInput = z.object({
  type: z.literal("FigmaNodeRender"),
  input: DTOFigmaNodeRenderIdInput.array(),
});

export const DTOFigmaNodeRenderAsyncActionInput = z.object({
  type: z.literal("FigmaNodeRenderAsync"),
  nodes: DTOFigmaNodeRenderInput.array(),
});

export type DTOFigmaNodeRenderActionInput = z.infer<typeof DTOFigmaNodeRenderActionInput>;
export type DTOFigmaNodeRenderAsyncActionInput = z.infer<typeof DTOFigmaNodeRenderAsyncActionInput>;
